import { IStore } from 'store/types';

export const selectSignUpUser = () => (state: IStore) => state.signUpUser;
